import { Base } from '../../abstract/base.model';
import { AgremoMapStatus } from './agremo-map-status.model';
import { isRecord } from '../utils/is-record';
import { countOrZero, nullableString } from '../utils/wire-value-utils';

/**
 * Uploaded drone imagery for a field, registered with Agremo. Built from the hub's map JSON
 * (`user-agremo-controller.ts` `/user/agremo/maps`, hub `data-models/agremo-map.ts`); the list adds `analysisCount`.
 *
 * Maps are created from a `CreateMapDto` and never updated, so every field is read-only. Fields the hub
 * didn't send stay `undefined` (an explicit `null` stays `null`); display fallbacks belong in templates.
 */
export class AgremoMap extends Base {
  organizationId?: string | null;
  fieldId?: string | null;
  agremoMapId?: string | null;
  mapName?: string | null;
  mapDate?: string | null;
  cameraType?: string | null;
  /** Missing status reads as 'uploading', the hub's initial state. */
  status: AgremoMapStatus;
  /** Specific failure reason when status is 'failed'. */
  errorMessage?: string | null;
  analysisCount: number;

  constructor(data: unknown) {
    super(data);
    const source = isRecord(data) ? data : {};
    this.organizationId = nullableString(source['organizationId']);
    this.fieldId = nullableString(source['fieldId']);
    this.agremoMapId = nullableString(source['agremoMapId']);
    this.mapName = nullableString(source['mapName']);
    this.mapDate = nullableString(source['mapDate']);
    this.cameraType = nullableString(source['cameraType']);
    this.status = (nullableString(source['status']) ?? 'uploading') as AgremoMapStatus;
    this.errorMessage = nullableString(source['errorMessage']);
    this.analysisCount = countOrZero(source['analysisCount']);
  }
}
